import styled from 'styled-components';
import { Modal as SemanticModal, Input as SemanticInput, ModalHeader as SemanticModalHeader } from 'semantic-ui-react';
import { Text as TextLayoutComponent, Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
    &.ui.modal {
    width: 530px;
  }
`;

export const Container = styled.div`
  padding: 20px;
`;

export const Title = styled(TextLayoutComponent)`
  margin-left: 142px;
  font-size: 18px;
  color: ${(props) => props.theme.color.secondary};
`;

export const ContainerBottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 15px;
`;

export const ButtonCancel = styled(ButtonLayoutComponent.Inverted)``;

export const ButtonSave = styled(ButtonLayoutComponent)``;

export const Input = styled(SemanticInput)``;

export const ModalHeader = styled(SemanticModalHeader)`
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  gap: 10px;
`;
